import React, { Fragment, useContext, useState } from "react";

import propTypes from "prop-types";
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { FiAlertCircle, FiCheckCircle, FiPrinter } from "react-icons/fi";
import { SessionContext } from "../../../../utility/useSession";
import { useTranslation } from "react-i18next";

enum DocumentStatus {
    idle = 0,
    generating = 1,
    completed = 2,
    errored = 3
}

const DocumentGenerator: React.FunctionComponent<{
    onRequestSerial: (data: Record<string, unknown>) => string;
    buttonBuilder?: (print: (data: Record<string, unknown>) => void) => React.ReactChild;
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const [documentStatus, setReportStatus] = useState<DocumentStatus>(DocumentStatus.idle);

    function downloadFile(data: BlobPart, filename: string, mime: string) {
        const blob = new Blob([data], { type: mime || 'application/octet-stream' });
        /*
                var reader = new FileReader();
                reader.readAsDataURL(blob); 
                reader.onloadend = function() {
                    const base64data = reader.result;
                    // For IE:
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(base64data);  
                    } // For webkit
                    else {
                        var objectUrl = URL.createObjectURL(base64data);
                        window.open(objectUrl);  
                    }
                }
        */

        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        // @ts-expect-error `msSaveBlob` does not exist on the `window.navigator` type.
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE doesn't allow using a blob object directly as link href.
            // Workaround for "HTML7007: One or more blob URLs were
            // revoked by closing the blob for which they were created.
            // These URLs will no longer resolve as the data backing
            // the URL has been freed."
            // @ts-expect-error `msSaveBlob` does not exist on the `window.navigator` type.
            window.navigator.msSaveBlob(blob, filename);
            return;
        }



        // Other browsers
        // Create a link pointing to the ObjectURL containing the blob
        const blobURL = window.URL.createObjectURL(blob);

        window.open(blobURL);

        /*setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL, this prevents chrome from downloading the PDF via the download button in PDF preview.
            // Disbaled in favor of chrome.
            // window.URL.revokeObjectURL(blobURL);
        }, 100);*/
    }

    const generatePDF = (data: Record<string, unknown>) => {
        setReportStatus(DocumentStatus.generating);
        const xhr = new XMLHttpRequest();

        xhr.open('POST', `${session.current.context.url}/documents/generateInvoice`, true);
        xhr.setRequestHeader("content-type", "application/json");
        xhr.setRequestHeader("authorization", session.current.context.headers.authorization);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status != 200) {
                    setReportStatus(DocumentStatus.errored);
                    setTimeout(() => {
                        setReportStatus(DocumentStatus.idle);
                    }, 2000);
                    return;
                }
                downloadFile(xhr.response, "document.pdf", "application/pdf");
                setReportStatus(DocumentStatus.completed);
                setTimeout(() => {
                    setReportStatus(DocumentStatus.idle);
                }, 2000);
            }
        };
        xhr.send(JSON.stringify({
            serial: props.onRequestSerial(data),
        }));
    }

    return (
        <Fragment>
            <Dialog
                open={documentStatus != DocumentStatus.idle}
                keepMounted

                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                {documentStatus == DocumentStatus.generating && (<Fragment><DialogTitle id="alert-dialog-slide-title">{t("documents.generate")}</DialogTitle>
                    <DialogContent>
                        <div style={{ textAlign: "center", paddingBottom: 20 }}>
                            <CircularProgress></CircularProgress>
                        </div>
                    </DialogContent></Fragment>)}
                {documentStatus == DocumentStatus.completed && (<Fragment><DialogTitle id="alert-dialog-slide-title">{t("documents.ready")}</DialogTitle>
                    <DialogContent>
                        <div style={{ textAlign: "center", paddingBottom: 20 }}>
                            <FiCheckCircle size={40} color="green"></FiCheckCircle>
                        </div>
                    </DialogContent></Fragment>)}
                {documentStatus == DocumentStatus.errored && (<Fragment><DialogTitle id="alert-dialog-slide-title">{t("documents.error")}</DialogTitle>
                    <DialogContent>
                        <div style={{ textAlign: "center", paddingBottom: 20 }}>
                            <FiAlertCircle size={40} color="red"></FiAlertCircle>
                        </div>
                    </DialogContent></Fragment>)}
            </Dialog>

            {props.buttonBuilder == null ? (<Button
                variant="contained"
                onClick={() => {
                    generatePDF({});
                }}><FiPrinter size={23} ></FiPrinter></Button>) : (
                <Fragment>{props.buttonBuilder((data) => generatePDF(data))}</Fragment>
            )}




        </Fragment>
    );
}

DocumentGenerator.propTypes = {
    onRequestSerial: propTypes.func.isRequired,
    buttonBuilder: propTypes.func

}
export default DocumentGenerator;